import React from "react";
import { Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useWidth from "../../hooks/useWidth";
import { convertToUrl } from "../../libraries/ercLibrary";

export default function FrequentlyAskedQuestions({ questions, product }) {
  const width = useWidth();
  const location = useLocation();
  const locationLand = location.pathname.includes("/land/");

  const settings = {
    dots: true, // This will show dot indicators at the bottom
    infinite: true,
    speed: 500,
    slidesToShow: width < 600 ? 1 : 2,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  const styleSlider = locationLand
    ? {
        maxWidth: width < 600 ? "90vw" : "75vw",
        overflow: "hidden",
        // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        margin: "0 0 1rem 0",
      }
    : {
        maxWidth: "100%",
        overflow: "hidden",
        // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        margin: "0 0 1rem 0",
      };

  return (
    <>
      <h1
        className={
          locationLand
            ? "padupside1 txtcenter fs125 bold-font"
            : "padupside1 txtcenter fs125 w90p bold-font"
        }
      >
        Sık Sorulan Sorular
      </h1>
      <h2
        className={
          locationLand
            ? "txtcenter fs125 padupsideq"
            : "txtcenter fs125 padupsideq w90p"
        }
      >
        Daha çok soru için <span className="beddo-border-bottom">KAYDIR</span>
      </h2>
      <p
        className={
          locationLand
            ? "txtcenter padupsideq marupsideq fs1"
            : "padupsideq marupsideq fs1"
        }
      >
        Aradığınız soru burada değil mi?{" "}
        <Link
          className="nodeco"
          to={`/sorucevap/${convertToUrl(product.name)}/${
            product._id
          }?product=${product.name}?image=${product.defaultImages[0]}`}
        >
          Tüm Soruları Okuyun
        </Link>
      </p>
      <div style={styleSlider}>
        {questions?.length > 0 && (
          <Slider {...settings}>
            {questions.map((text, index) => {
              const question = text.split("?")[0]?.trim();
              const answer = text.split("?")[1]?.trim();

              return (
                <div key={index} className="row-left">
                  <div className="mar1 fs125 shadow-all rad5r">
                    <p className="bold-font padh w95p">* {question}?</p>
                    <p className="pad1 w90p">{answer}</p>
                  </div>
                  <div className="white w30p">c</div>
                </div>
              );
            })}
          </Slider>
        )}
      </div>
    </>
  );
}
